/**
 * Constants returned in accountSettings, but not defined in Nucleus
 */
export enum ACCOUNT_TIER {
  ENTERPRISE = 'ENTERPRISE',
  TRIAL = 'TRIAL'
}

export enum ACTIVE_FEATURE_STATUS {
  PAID = 'PAID',
  TRIAL = 'TRIAL',
  ACTIVATED = 'ACTIVATED'
}

export const accountTier = [
  ACCOUNT_TIER.ENTERPRISE,
  ACCOUNT_TIER.TRIAL
];

export const activeFeatureStatus = [
  ACTIVE_FEATURE_STATUS.ACTIVATED,
  ACTIVE_FEATURE_STATUS.PAID,
  ACTIVE_FEATURE_STATUS.TRIAL
];
